import { useEffect } from "react";
import styled from "@emotion/styled";
import { Grid, CardHeader } from "@mui/material";

import { BasicFlex } from "../../../utils/Common";

import { useFormikContext } from "formik";

import { useQuery } from "@tanstack/react-query";

import { getAppointmentHistory } from "../../Customers/apiService";

import AppointmentHistory from "../../Customers/Components/AppointmentHistory";

import TimelineComponent from "../../../utils/utilities/Timeline";

import { useFormData } from "../../../contexts/FormData";

import FollowUps from "./FollowUps";

import WeddingDate from "../../Customers/Components/WeddingDate";

import useFollowUpSnackbarStore from "../../../store/repair_follow_up";

const Container = styled.div`
  background-color: ${props => props.theme.colors.lightBg};
  padding: 1.6rem;
  border-radius: 8px;
`

const CommentsContainer = styled(Container)`
  /* background-color: ${props => props.theme.colors.darkBg}; */
  border: 2px dashed ${props => props.theme.colors.border};
`

const CustomerInfo = () => {

  const { values, setFieldValue } = useFormikContext() || {};

  const { formValues } = useFormData() || {};

  // const fu_open = useFollowUpSnackbarStore(state => state.open);
  // const fu_customer_id = useFollowUpSnackbarStore(state => state.customer_id);

  // console.log(values, "values");

  // useEffect(() => {
  //   if (fu_open) {
  //     console.log(fu_customer_id, "fu_customer_id!!!!!!!!!!!!!!!!!!!!");
  //     setFieldValue("customer_id", fu_customer_id);
  //     // selectRepair();
  //   }
  // }, [fu_open]);

  const { data: history, isLoading } = useQuery({
    queryKey: ['customers', 'history', values?.customer_id],
    queryFn: () => getAppointmentHistory(values?.customer_id),
    enabled: !!values?.customer_id
  })

  if (!values?.customer_id) return null;

  return (
      <Grid item size={{xs: 12}}>
        <Grid container spacing={3}>
          <Grid size={{xs: 12}}>
            <FollowUps />
          </Grid>
          <Grid size={{xs: 12}}>
            <WeddingDate date={formValues?.wedding_date} />
          </Grid>
          <Grid size={{xs: 12}}>
            <Container>
              <AppointmentHistory history={history} loading={isLoading} client_name={formValues?.customer_name} />
            </Container>
          </Grid>
          <Grid size={{xs: 12}}>
            <CommentsContainer>
              <CardHeader title={`Customer Notes for ${formValues?.customer_name}`} sx={{p: 1}} />
              <TimelineComponent resource="customers" resource_id={values?.customer_id} />
            </CommentsContainer>
          </Grid>
        </Grid>
      </Grid>
  )

};

export default CustomerInfo;